import { Dispatch, SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';
import { DialogConfirmation } from '../../../../../../components/dialog/confirmation';

type UpdateFailedPopupProps = {
  show: boolean;
  setShow: Dispatch<SetStateAction<boolean>>;
  cancelControllerUpdateAndTryAgain: () => Promise<void>;
};

export const UpdateFailedPopup: React.FC<UpdateFailedPopupProps> = ({
  show,
  setShow,
  cancelControllerUpdateAndTryAgain,
}) => {
  const { t } = useTranslation('device-info');
  const { t: tc } = useTranslation('common');

  return (
    <DialogConfirmation
      show={show}
      setShow={setShow}
      header={`${t('exalus.updateResult.Error')}!`}
      content={`${t('exalus.updateResult.UpdateInstallationFailed')}!`}
      primaryBtnText={tc('buttons.tryAgain')}
      secondaryBtnText={tc('buttons.cancel')}
      secondaryBtnAction={() => setShow(false)}
      primaryBtnAction={cancelControllerUpdateAndTryAgain}
    />
  );
};
